import type { User } from '@devhacker/shared/features/user/types/user';
import type { UserAvatar } from '@devhacker/shared/features/user/types/userAvatar';

export const isObject = (val: unknown): val is Record<any, any> =>
  val !== null && typeof val === 'object';

export type OldUserData = {
  name?: string;
  email?: string;
  avatars: { [propName: string]: string | null };
  sub?: string | null;
  banned?: boolean;
  avatar: string | null;
};

export const normalizeUserData = (data: User): OldUserData => {
  const def: OldUserData = {
    name: 'unknown',
    email: 'unknown',
    sub: null,
    banned: false,
    avatars: {},
    avatar: null,
  };

  if (!isObject(data)) {
    return def;
  }

  const avatars: OldUserData['avatars'] = {};
  if (data.avatars && data.avatars.length) {
    data.avatars.forEach((avatar: UserAvatar): void => {
      avatar && (avatars[avatar.size] = avatar.url);
    });
  }

  return {
    avatar: avatars.m || avatars.s || avatars.l || avatars.xs || null,
    avatars,
    name: data.display_name || def.name,
    email: data.email || def.email,
    sub: data.integer_id || def.sub,
    banned: Boolean(data.banned_at),
  };
};
